document.addEventListener('DOMContentLoaded', function() {
  // Sélectionnez l'élément de menu pour la version mobile
  var rendezVousMenuItemMobile = document.querySelector('#HeaderDrawer-a-propos-prendre-rendez-vous');
  if (rendezVousMenuItemMobile) {
    rendezVousMenuItemMobile.addEventListener('click', function(event) {
      event.preventDefault(); // Empêche le comportement de lien par défaut
      Calendly.showPopupWidget('https://calendly.com/chateau14/30min?primary_color=1a1a1a'); // Remplacez l'URL par celle de votre pop-up Calendly
    });
  }

  // Sélectionnez l'élément de menu pour la version de bureau
  var rendezVousMenuItemDesktop = document.querySelector('#HeaderMenu-a-propos-prendre-rendez-vous');
  if (rendezVousMenuItemDesktop) {
    rendezVousMenuItemDesktop.addEventListener('click', function(event) {
      event.preventDefault(); // Empêche le comportement de lien par défaut
      Calendly.showPopupWidget('https://calendly.com/chateau14/30min?primary_color=1a1a1a'); // Remplacez l'URL par celle de votre pop-up Calendly
    });
  }
});
window.onload = function() {
  // Vérifier si l'appareil est un appareil mobile
  if (/Mobi|Android/i.test(navigator.userAgent)) {
    // Retirer la section sur mobile
    var utilityBar = document.querySelector('.utility-bar.color-accent-1.gradient.utility-bar--bottom-border');
    if (utilityBar) {
      utilityBar.parentNode.removeChild(utilityBar);
    }
  }
};
